const sx = {
  container: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    position: 'relative',
  },
  arrows: {
    position: 'absolute',
    top: '50%',
    zIndex: 1,
    width: '36px',
    height: '36px',
    borderRadius: '36px',
    cursor: 'pointer',
    backgroundColor: 'grey.800',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '&:hover': {
      backgroundColor: 'grey.600',
    },
  },
  sliderContainer: (activeSlide: number) => ({
    display: 'flex',
    height: '100%',
    transition: 'transform 0.3s ease',
    transform: `translateX(-${activeSlide * 100}%)`,
  }),
  itemContainer: {
    display: 'flex',
    flex: '0 0 100%',
    boxSizing: 'border-box',
    position: 'relative',
  },
  loaderBackground: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(33, 43, 54, 0.3)',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
  },
};

export default sx;